import React from 'react';
import { styled } from '@mui/material/styles';
import { OngoingRevisions } from './OngoingRevisions';
import { LastRevisedGuides } from './LastRevisedGuides';
import { CompletedRevisions } from './CompletedRevisions';
import { PopularGuides } from './PopularGuides';
import { RegulationChanges } from './RegulationChanges';
import { Notices } from './Notices';
import { SearchTermStats } from './SearchTermStats';
import { Typography, Grid2 as Grid } from '@mui/material';
import { ReleasesStats } from './ReleasesStats';
const PREFIX = 'Overview';

const classes = {
  sectionHeader: `${PREFIX}-sectionHeader`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.sectionHeader}`]: {
    paddingTop: theme.spacing(1.5),
    color: theme.palette.text.secondary,
    fontSize: '1.2rem',
  },
}));

export function Overview() {
  return (
    <StyledGrid container>
      <Grid size={{ xs: 4 }}>
        <RegulationChanges />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <Notices />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography variant="h5" className={classes.sectionHeader}>
          Aktivitet
        </Typography>
        <ReleasesStats />
        <CompletedRevisions />
        <LastRevisedGuides />
        <OngoingRevisions />
      </Grid>
      <Grid size={{ xs: 6 }}>
        <Typography variant="h5" className={classes.sectionHeader}>
          Brukerstatistikk
        </Typography>
        <PopularGuides />
        <SearchTermStats />
      </Grid>
    </StyledGrid>
  );
}
